import React from 'react';
import './LegalSnackbar.css'
import {
  LEGAL_TEXT,
  closeSnackbar
} from '../../constants/content'
const LegalSnackbar = () => {
  return (
    <div id="legal-snackbar" className="legal-snackbar">
      {/* {LEGAL_TEXT} */}
      {/* {text} */}
      <div id="legal-snackbar-text"></div>
      <div onClick={closeSnackbar} style={{cursor: 'pointer'}}>x</div>
    </div>
  )
}

export default LegalSnackbar
